<template>
     <el-row :gutter="8" class="simple-table-item">
        <template v-if="!notFirst">
            <el-col :span="8">
                <ip-keyword-choice :text="field" :keywordList="fieldList" @selectField="handleField" @changeField="handleChangeField"></ip-keyword-choice>
            </el-col>
        </template>
        <template v-if="notFirst">
            <el-col :span="3">
                <el-select size="small" v-model="operateValue" @change="operateChange">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"></el-option>
                </el-select>
            </el-col>
            <el-col :span="5">
                <ip-keyword-choice :text="field" :keywordList="fieldList"  @selectField="handleField" @changeField="handleChangeField"></ip-keyword-choice>
            </el-col>
        </template>
        <el-col :span="15">
            <template v-if="inputType === 'input'">
                <el-autocomplete style="width: 100%;"
                        class="inline-input"
                        size="small"
                        v-model="inputValue"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @keyup.enter.native="handleKeyUpEvent"
                        :maxlength="maxlength?maxlength:255">
                </el-autocomplete>
            </template>    
            <template v-if="inputType === 'searchInput'">
                 <el-autocomplete style="width: 100%;"
                        class="inline-input"
                        size="small"
                        v-model="inputValue"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @keyup.enter.native="handleKeyUpEvent"
                        :maxlength="maxlength?maxlength:255">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearchEvent"></el-button>
                </el-autocomplete>
            </template>
        </el-col>
        <template v-if="isShowDelBtn">
            <el-col :span="1">
                <el-button icon="el-icon-delete" size="small" @click.native="deleteItem"></el-button>
            </el-col>
        </template>
    </el-row>
</template>
<script>
export default {
    name:'ipSimpleSearchItem',
    props:{
        notFirst:{type:Boolean,default:false},
        index:{type:Number,default:0},
        operate:{type:String,default:''},
        field:{type:String,default:''},
        fieldValue:{type:String,default:''},
        input:{type:String,default:''},
        autoList:{type:Array,default(){return[]}},
        isShowDelBtn:{type:Boolean,default:true},
        fieldList:{type:Array,default(){return[]}},
        maxlength:{type:Number, default:255},
        inputType:{type:String,default:'input'}
    },
    data(){
        return{
              options: [{
                            value: 'AND',
                            label: 'AND'
                        }, {
                            value: 'OR',
                            label: 'OR'
                        }, {
                            value: 'NOT',
                            label: 'NOT'
                        }, {
                            value: 'XOR',
                            label: 'XOR'
                        }],
                        operateValue:'',
                        inputValue:'',
                        timeout:  null
        }
    },
    mounted(){
        this.operateValue = this.operate;
        this.inputValue = this.input;
    },
    watch:{
        inputValue(newValue){
            this.$emit('data-item', {
                index:this.index,
                operate:this.operate,
                field: this.field ,
                fieldValue:this.fieldValue,
                input:newValue,
            });
        },
        operate(newValue){
            this.operateValue = newValue;
        },
        input(newValue){
            this.inputValue = newValue;
        }
    },
    methods:{
        handleSearchEvent(){
            let msg = {
                field:this.field,
                fieldValue:this.fieldValue,
                index:this.index
            }
            this.$emit('search-event',msg);
        },
        handleKeyUpEvent(){
            this.$emit('key-up-event');
        },
        handleField(msg){
            this.$emit('data-item', {
                index:this.index,
                operate:this.operate,
                field:msg.text,
                fieldValue:msg.value,
                input:this.inputValue,
                maxlength: msg.maxlength
            });
        },
        deleteItem(){
            this.$emit('delete-item',this.index);
        },
        querySearchAsync(queryString, callback){
            const self = this;
            clearTimeout(self.timeout);
            self.timeout = setTimeout(() => {
                callback(self.autoList);
            }, 20);

            let temp={
                field:this.field,
                fieldValue:this.fieldValue,
                queryString:queryString
            }
            self.$emit('query-search',temp);
        },
        operateChange(){
            this.$emit('data-item', {
                index:this.index,
                operate:this.operateValue,
                field:this.field ,
                fieldValue:this.fieldValue,
                input:this.inputValue,
                maxlength: this.maxlength
            });
        },
        handleChangeField(value){
            this.$emit('change-field',value);
        }
    }
}
</script>
<style lang="scss" scoped>
.simple-table-item {
    margin: 8px 0;
    font-size: 14px;
}
</style>
